import React, { Fragment, useCallback, useEffect, useRef, useState } from 'react';

import { useLocation, useMedia } from 'react-use';
import { showToast } from '../shared/Toast';
import {
  KitCategories,
  KitDocumentModel,
  MediaKitModel,
  MediaKitSettingModel,
} from '../submission_kits/components/KitModels';
import mediaKitService from '../services/MediaKitService';
import { KitDocumentType, SbCurrentUser } from '../submission_boards/component/SbModel';
import { Dialog, Transition, Menu } from '@headlessui/react';
import Button from '../submission_boards/component/Button';
import FilePreviewer from '../submission_kits/components/FilePreviewer';
import {
  CircleXIcon,
  CropIcon,
  EllipsisVerticalIcon,
  FileXIcon,
  InfoIcon,
  LayoutGridIcon,
  LayoutListIcon,
  ListFilterIcon,
  PencilIcon,
  PlusIcon,
  RefreshCcwIcon,
  RepeatIcon,
  Trash2Icon,
  TriangleAlertIcon,
  XIcon,
} from 'lucide-react';
import kitDocumentService from '../services/KitDocumentService';
import ConfirmationDialog from '../shared/ConfirmationDialog';
import CustomUppyUploaderv2 from '../submission_kits/components/CustomUppyUploaderv2';
import CropImage from '../shared/CropImage';
import mk_empty from '../../../assets/images/mk_empty.svg';
import whiteBgSbProfile from '../../../assets/images/white_bg_sb_profile.jpeg';
import ViewMediaModel from '../submission_kits/components/ViewMediaModel';
import { useIsMobile } from '../submission_boards/component/useIsMobile';
import VideoThumbnailSelector from '../shared/VideoThumbnailSelector';
import { CameraIcon } from 'lucide-react';

export interface MediaKitsPageProps {
  currentUser: SbCurrentUser;
}
export default function MediaKitsPagev2({ currentUser }: MediaKitsPageProps) {
  // const [records, setRecords] = useState<SubmissionKitModel[]>([]);
  const location = useLocation();
  const isMobile = useIsMobile();
  // console.log('location', location);
  const [mediaKit, setMediaKit] = useState<MediaKitModel>();
  // const [imageCount, setImageCount] = useState<number>(0);
  // const [videoCount, setVideoCount] = useState<number>(0);
  // const [imageAllowed, setImageAllowed] = useState<boolean>(false);
  // const [videoAllowed, setVideoAllowed] = useState<boolean>(false);
  const [mediaSetting, setMediaSetting] = useState<MediaKitSettingModel>({
    imageCount: 0,
    videoCount: 0,
    imageAllowed: 0,
    videoAllowed: 0,
  });

  const version: number = 2;
  // const ImageType: number = 1;
  // const VideoType: number = 2;
  const MaxImageSizeMb: number = 30;
  const MaxVideoSizeMb: number = 1*1024*11;
  const getUrlFilter = () => {
    if (typeof window === 'undefined') return {};
    const searchParams = new URLSearchParams(window.location.search);
    const tabFilter = searchParams.get('tab') || 'photos';
    
    return { tab: tabFilter };
  };

  const [showMediaBig, setshowMediaBig] = useState<KitDocumentModel | null>(null);

  const [showCropModal, setshowCropModal] = useState<boolean>(false);
  const [showReplaceModal, setshowReplaceModal] = useState<boolean>(false);
  
  const [tabSelected, setTabSelected] = useState<string>(() => getUrlFilter().tab);
  const [showUploadMediaImage, setshowUploadMediaImage] = useState<boolean>(false);
  const [showUploadMediaVideo, setshowUploadMediaVideo] = useState<boolean>(false);
  const [isUploadedMedia, setIsUploadedMedia] = useState<boolean>(false);
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] = useState(false);
  const [kitDocumentDelete, setKitDocumentDelete] = useState(null);
  const [showForceDeleteModal, setShowForceDeleteModal] = useState(false);

  const [sortMode, setSortMode] = useState<'new' | 'old' | 'name'>('new');
  const [viewMode, setViewMode] = useState<'grid' | 'list'>('grid');
  const [mediaKitDocuments, setMediaKitDocuments] = useState<KitDocumentModel[]>([]);
  const [mediaKitDocumentsImagePresent, setMediaKitDocumentsImagePresent] =
    useState<boolean>(false);
  const [mediaKitDocumentsVideoPresent, setMediaKitDocumentsVideoPresent] =
    useState<boolean>(false);

  const [mediaKitDocumentSelected, setMediaKitDocumentSelected] = useState<KitDocumentModel | null>(
    null
  );
  const [mediaKitDocumentCropSelected, setMediaKitDocumentCropSelected] =
    useState<KitDocumentModel | null>(null);
  const [selectedThumbnailKit, setSelectedThumbnailKit] = useState<KitDocumentModel | null>(null);

  // const [editFileName, setEditFileName] = useState<boolean>(false);
  const inputFileNameRefImageG = useRef<HTMLInputElement>(null);
  const inputFileNameRefImageL = useRef<HTMLInputElement>(null);
  const inputFileNameRefVideoG = useRef<HTMLInputElement>(null);
  const inputFileNameRefVideoL = useRef<HTMLInputElement>(null);
  const refMap = {
    image_g: inputFileNameRefImageG,
    image_l: inputFileNameRefImageL,
    video_g: inputFileNameRefVideoG,
    video_l: inputFileNameRefVideoL,
  };
  const [refField, setrefField] = useState<string>('');
  const [editFileNameIndex, setEditFileNameIndex] = useState<number>(-1);
  const [editFileName, setEditFileName] = useState<string>('');
  const [menuPosition, setMenuPosition] = useState('top');

  const [mediaKitDocumentSelectedRename, setMediaKitDocumentSelectedRename] =
    useState<KitDocumentModel | null>(null);

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [page, setPage] = useState<number>(1);
  const observerRef = useRef(null);
  const listRef = useRef(null);
  const [noMoreData, setNoMoreData] = useState<string>('');
  const perPage: number = 12; // Number of records to fetch per page
  const [errorMessage, setErrorMessage] = useState('');

  const is400_639Screen = useMedia('(min-width: 400px) and (max-width: 639px)', false);

  // const loadMore = async (from: string) => {
  //   if (isLoading) {
  //     console.log('sb: loadMore isLoading is true from ' + from);
  //     return;
  //   }
  //   console.log('sb: set isLoading to true, isLoading was false from ' + from);
  //   setIsLoading(true);
  // };
  // useEffect(() => {
  //   if (isLoading) {
  //     console.log('sb::useEffect[isLoading] call fetchSubmissionBoards page: ' + page);
  //     const load = async () => {
  //       await fetchMediaKits(page);
  //     };
  //     load();
  //   }
  // }, [isLoading]);

    useEffect(() => {
      if (editFileNameIndex !== null && refField != '' && refMap[refField].current) {
        refMap[refField].current.focus();
        refMap[refField].current.select();
      }
    }, [editFileNameIndex]);
  
  // Load first page
  useEffect(() => {
    console.log('useEffect:sortMode[] ', sortMode);
    fetchMediaKits(1, true, true);
  }, [sortMode]);

  // Auto-fill screen after render
  // useEffect(() => {
  //   const checkIfMoreNeeded = async () => {
  //     const listBottom = listRef.current?.getBoundingClientRect().bottom || 0;
  //     // console.log('sb::winodws listBottom', listBottom, window.innerHeight);
  //     if (listBottom < window.innerHeight) {
  //       console.log('sb::winodw height more: call loadmore');
  //       await loadMore('checkIfMoreNeeded');
  //     }
  //   };

  //   checkIfMoreNeeded();
  //   window.addEventListener('resize', checkIfMoreNeeded);

  //   return () => window.removeEventListener('resize', checkIfMoreNeeded);
  // }, [mediaKitDocuments]);

  // Infinite scroll on reaching bottom
  // useEffect(() => {
  //   const observer = new IntersectionObserver(([entry]) => {
  //     if (entry.isIntersecting) {
  //       console.log('sb::last element visible');
  //       loadMore('[lastelementvisible]');
  //     }
  //   });

  //   if (observerRef.current) {
  //     observer.observe(observerRef.current);
  //   }

  //   return () => observer.disconnect();
  // }, []);

  const setFlags = (kit_documents: any) => {
    setMediaKitDocumentsImagePresent(
      kit_documents.filter((kit_document) => kit_document.file_content_type.startsWith('image'))
        .length > 0
    );
    setMediaKitDocumentsVideoPresent(
      kit_documents.filter((kit_document) => kit_document.file_content_type.startsWith('video'))
        .length > 0
    );
    setshowUploadMediaImage(
      kit_documents.filter((kit_document) => kit_document.file_content_type.startsWith('image'))
        .length <= 0
    );
    setshowUploadMediaVideo(
      kit_documents.filter((kit_document) => kit_document.file_content_type.startsWith('video'))
        .length <= 0
    );
  };
  const fetchMediaKits = async (pageParam: number, doMediaSetting: boolean, doFlagSetting: boolean ) => {
    try {
      // if (noMoreData.length > 0 && pageParam != 0) {
      //   console.log('fetchSubmissionBoards no more data is set');
      //   return;
      // }
      setIsLoading(true);
      console.log('sb: fetchMediaKits In');
      if (mediaKitDocuments && mediaKitDocuments.length <= 0) {
        pageParam = 1;
      }
      let filter = '';
      const responseData = await mediaKitService.fetchMediaKits(
        filter,
        sortMode,
        pageParam,
        999999
      );
      if (responseData) {
        if (doMediaSetting) {
          let mediasetting: MediaKitSettingModel = { ...mediaSetting };
          if (responseData.image_count != undefined) {
            // setImageCount(responseData.image_count);
            mediasetting.imageCount = responseData.image_count;
          }
          if (responseData.video_count != undefined) {
            // setVideoCount(responseData.video_count);
            mediasetting.videoCount = responseData.video_count;
          }
          if (responseData.allowed_image != undefined) {
            // setImageAllowed(responseData.allowed_image);
            mediasetting.imageAllowed = responseData.allowed_image;
          }
          if (responseData.allowed_video != undefined) {
            // setVideoAllowed(responseData.allowed_video);
            mediasetting.videoAllowed = responseData.allowed_video;
          }
          setMediaSetting(mediasetting);
        }
        if (responseData.media_kit) {
          setMediaKit(responseData.media_kit);
        }
        if (responseData.kit_documents.length > 0) {
          if (responseData.kit_documents.length == perPage) {
            console.log('sb: fetchMediaKits page:', page);
            setPage((prev) => prev + 1);
            setNoMoreData('');
          } else {
            setNoMoreData('No more media...');
          }
          // If page 1 or mediaKitDocuments is null/empty, replace instead of append
          if (pageParam === 1 || !mediaKitDocuments || mediaKitDocuments.length === 0) {
            if (doFlagSetting) {
              setFlags(responseData.kit_documents);
            }
            setMediaKitDocuments(responseData.kit_documents);
          } else {
            setMediaKitDocuments((prevRecords) => {
              let kitDocs = [...prevRecords, ...responseData.kit_documents];
              setFlags(kitDocs);
              return kitDocs;
            });
          }
        } else {
          if (pageParam === 1) {
            setMediaKitDocumentsImagePresent(false);
            setMediaKitDocumentsVideoPresent(false);
            setshowUploadMediaImage(true);
            setshowUploadMediaVideo(true);
            setMediaKitDocuments([]);
          }
          setNoMoreData('No more media...');
        }
        return;
      }
      if (mediaKitDocuments && mediaKitDocuments.length <= 0 && pageParam == 1) {
        setNoMoreData('No more media...');
      }
    } catch (error) {
      showToast('Error while fetching submission kits.', 'danger');
    } finally {
      console.log('sb: fetchMediaKits Out');
      console.log('sb: isLoading false');
      setIsLoading(false);
    }
  };

  const refreshClicked = async () => {
    setIsLoading(true);
    setNoMoreData('');
    setPage(1);
    setMediaKitDocuments([]);
    setTimeout(() => {
      fetchMediaKits(1, true, true);
    }, 500);
  };

  const renameFileMedia = async (kit_document: any, fileName: string) => {
    try {
      if (kit_document.id !== undefined && kit_document.id > 0) {
        const resp = await mediaKitService.renameFileMediaKitDocument(
          mediaKit.uuid,
          kit_document.id,
          fileName
        );
        if (resp) {
          let _mediaKitDocuments = [...mediaKitDocuments];
          let present: boolean = false;
          for (let indexRecs = 0; indexRecs < _mediaKitDocuments.length; indexRecs++) {
            const item = _mediaKitDocuments[indexRecs];
            if (item.id === kit_document.id) {
              _mediaKitDocuments[indexRecs].file_name = fileName;
              _mediaKitDocuments[indexRecs].cropped_file_name = fileName;
              break;
            }
          }

          if (sortMode === 'name') {
            _mediaKitDocuments.sort((a, b) => 
              a.file_name.toLowerCase().localeCompare(b.file_name.toLowerCase())
            );
          }

          setFlags(_mediaKitDocuments);
          setMediaKitDocuments(_mediaKitDocuments);
          showToast('Successfully Renamed', 'success');
          return true;
        }
      }
    } catch (error) {
      throw error;
    }
    return false;
  };
  const renameFileMediaClickHandler = async (
    kit_document: any,
    index: number,
    fileName: string
  ) => {
    try {
      event.preventDefault();
      await renameFileMedia(kit_document, fileName);
    } catch (error) {
      showToast('Error in removing media', 'danger');
    }
  };

  const handleFileNameBlur = async (kit_document: any, index: number, newName: string) => {
    // Only save if the name actually changed
    if (newName.trim() && newName !== kit_document.file_name) {
      try {
        await renameFileMedia(kit_document, newName);
      } catch (error) {
        showToast('Error in renaming media', 'danger');
      }
    }
    setrefField('');
    setEditFileNameIndex(-1);
  };

 const removeMedia = async (kit_document: any, force: boolean = false) => {
      try {
        if (kit_document.id !== undefined && kit_document.id > 0) {
          const resp = await mediaKitService.deleteMediaKitDocument(mediaKit.uuid, kit_document.id, force);
          
          if (resp && resp.requires_confirmation) {
            setShowForceDeleteModal(true);
            return false;
          }
          
          if (resp && resp.status === 'success') {
            let _mediaKitDocuments = [...mediaKitDocuments];
            for (let indexRecs = 0; indexRecs < _mediaKitDocuments.length; indexRecs++) {
              const item = _mediaKitDocuments[indexRecs];
              if (item.id === kit_document.id) {
                _mediaKitDocuments.splice(indexRecs, 1);
                break;
              }
            }
            let _mediaSetting = { ...mediaSetting };
            if (kit_document.file_content_type.startsWith('image')) {
              _mediaSetting.imageAllowed++;
              _mediaSetting.imageCount--;
            } else if (kit_document.file_content_type.startsWith('video')) {
              _mediaSetting.videoAllowed++;
              _mediaSetting.videoCount--;
            }
            setMediaSetting(_mediaSetting);
            setFlags(_mediaKitDocuments);
            setMediaKitDocuments(_mediaKitDocuments);
            showToast('Successfully Removed', 'success');
            return true;
          }
        }
      } catch (error) {
        throw error;
      }
      return false;
    };

    const handleDeleteMediaClicked = async () => {
    if (kitDocumentDelete == null) return;
    try {
      const deleted = await removeMedia(kitDocumentDelete);
      if (deleted) {
        hideDeleteConfirm();
      } else {
        setShowDeleteConfirmationModal(false);
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.error || error?.response?.data?.message || 'Error';
      showToast(errorMessage, 'danger');
    }
  };

const handleForceDeleteClicked = async () => {
  if (kitDocumentDelete == null) return;
  try {
    await removeMedia(kitDocumentDelete, true);
    setShowForceDeleteModal(false);
    setKitDocumentDelete(null);
  } catch (error) {
    showToast('Error in deleting media', 'danger');
  }
};
  const removeMediaClickHandler = async (event: any, kit_document: any, index: number) => {
    try {
      event.preventDefault();
      setKitDocumentDelete(kit_document);
      setShowDeleteConfirmationModal(true);
    } catch (error) {
      showToast('Error in removing media', 'danger');
    }
  };
  const removeCropMedia = async (kit_document: any) => {
    try {
      if (kit_document.id !== undefined && kit_document.id > 0) {
        const resp = await mediaKitService.deleteCropMediaKitDocument(
          mediaKit.uuid,
          kit_document.id
        );
        if (resp) {
          let _mediaKitDocuments = [...mediaKitDocuments];
          let present: boolean = false;
          for (let indexRecs = 0; indexRecs < _mediaKitDocuments.length; indexRecs++) {
            const item = _mediaKitDocuments[indexRecs];
            if (item.id === kit_document.id) {
              _mediaKitDocuments[indexRecs].cropped_file_url = null;
              _mediaKitDocuments[indexRecs].cropped_file_name = null;
              _mediaKitDocuments[indexRecs].cropped_file_content_type = null;
              break;
            }
          }
          setFlags(_mediaKitDocuments);
          setMediaKitDocuments(_mediaKitDocuments);
          showToast('Successfully Resetted to Original media', 'success');
          return true;
        }
      }
    } catch (error) {
      throw error;
    }
    return false;
  };
  const removeCropMediaClickHandler = async (event: any, kit_document: any, index: number) => {
    try {
      event.preventDefault();
      await removeCropMedia(kit_document);
    } catch (error) {
      showToast('Error in removing media', 'danger');
    }
  };

  const hideDeleteConfirm = () => {
    console.log('Delete set null');
    setKitDocumentDelete(null);
    console.log('Delete set null done');
    setShowDeleteConfirmationModal(false);
  };
    // const targetDivRef = useRef(null);
  
    //   const scrollToMenuTarget = () => {
    //     if (targetDivRef.current) {
    //       console.log('scrollToMenuTarget image')
    //       // Use the native DOM API to scroll the element into the viewport
    //       targetDivRef.current.scrollIntoView({
    //         behavior: 'smooth', // Optional: for a smooth scrolling animation
    //         block: 'start',     // Optional: aligns the element's start (top) with the viewport's start
    //       });
    //     } else {
    //       setTimeout(() => {
    //         scrollToMenuTarget();
    //       }, 1000);
    //     }
    //   };
  const getMenuItemsImage = (kit_document: KitDocumentModel, index: number) => {
    // const info = getFlexWrapLineInfo('flex-container');
    // info.forEach(item => {
    // console.log(`Element: ${item.element.textContent?.trim()}, Line: ${item.lineNumber}`);
    // });

    return (
      <Menu.Items 
      // ref={targetDivRef}
      className={"absolute -right-1 mt-2 w-48 focus:outline-none z-10" + 
        (menuPosition == 'bottom'?'   origin-top-right top-full ' : ' origin-bottom-right bottom-full ')
      }>
        <div
          className={"absolute right-0 text-gray-300 text-center items-center flex w-4 h-4" +
        (menuPosition == 'bottom'?'  top-0  ' : ' bottom-0 ')
            
          }
          style={{
            zIndex: 51,
            top: menuPosition == 'bottom'?'-10px':'',
            bottom: menuPosition == 'top'?'-10px':'',
            right: '12px',
            width: '1rem',
          }}
        >
          <div
            className={"absolute   w-4 h-4 border-t-2 border-l-2 border-gray-300  bg-white" +
        (menuPosition == 'bottom'?' top-0 left-1/2 -translate-x-1/2 transform rotate-45 ' : ' bottom-0 left-1/2 transform -translate-x-1/2 ')

            }
            style={{
              zIndex: 51,
              '--tw-rotate':  menuPosition == 'bottom'?'45deg':'225deg',
              top: menuPosition == 'bottom'?'2px':'',
              bottom: menuPosition == 'top'?'2px':'',
              right: '1.5rem',
            }}
          />
        </div>

        <div className="rounded-md py-1 px-1 gap-1 border-gray-300 border bg-white box-shadow-100 ring-1 ring-black ring-opacity-5 flex flex-col">
          <Menu.Item>
            {({ active }) => (
              <div
                className="cursor-pointer px-2 py-1 gap-2-1 hover:bg-gray-100"
                onClick={(event: React.MouseEvent) => {
                  // event.preventDefault();
                  if (version == 2) {
                    setMediaKitDocumentCropSelected(kit_document);
                    setshowCropModal(true);
                  } else {
                    showToast('WIP', 'danger');
                  }
                }}
              >
                <div className="flex flex-row items-center font-medium text-md p-0 gap-2">
                  <CropIcon className="w-4 h-4" />
                  Crop
                </div>
              </div>
            )}
          </Menu.Item>
          <Menu.Item>
            {({ active }) => (
              <div
                className="cursor-pointer px-2 py-1 gap-2-1 hover:bg-gray-100"
                onClick={(event: React.MouseEvent) => {
                  // event.preventDefault();
                  if (version == 2) {
                    setMediaKitDocumentSelectedRename(kit_document);
                    setEditFileNameIndex(index);
                    if(viewMode == 'grid')
                    {
                      setrefField('image_g');
                    } else {
                      setrefField('image_l');
                    }
                    setEditFileName(kit_document.file_name);
                  } else {
                    showToast('WIP', 'danger');
                  }
                }}
              >
                <div className="flex flex-row items-center font-medium text-md p-0 gap-2">
                  <PencilIcon className="w-4 h-4" />
                  Rename
                </div>
              </div>
            )}
          </Menu.Item>
          <Menu.Item>
            {({ active }) => (
              <div
                className="cursor-pointer px-2 py-1 gap-2-1 hover:bg-gray-100"
                onClick={(event: React.MouseEvent) => {
                  // event.preventDefault();
                  if (version == 2) {
                    setMediaKitDocumentSelected(kit_document);
                    setshowReplaceModal(true);
                  } else {
                    showToast('WIP', 'danger');
                  }
                }}
              >
                <div className="flex flex-row items-center font-medium text-md p-0 gap-2">
                  <RepeatIcon className="w-4 h-4" />
                  Replace
                </div>
              </div>
            )}
          </Menu.Item>
          {kit_document.cropped_file_url && kit_document.cropped_file_url != '' && (
            <Menu.Item>
              {({ active }) => (
                <div
                  className="cursor-pointer px-2 py-1 gap-2-1 hover:bg-gray-100"
                  onClick={async (event: React.MouseEvent) => {
                    // event.preventDefault();
                    if (version == 2) {
                      setMediaKitDocumentSelected(kit_document);
                      await removeCropMediaClickHandler(event, kit_document, index);
                      // setshowReplaceModal(true);
                    } else {
                      showToast('WIP', 'danger');
                    }
                  }}
                >
                  <div className="flex flex-row items-center font-medium text-md p-0 gap-2">
                    <RefreshCcwIcon className="w-4 h-4" />
                    Original Image
                  </div>
                </div>
              )}
            </Menu.Item>
          )}
          <Menu.Item>
            {({ active }) => (
              <div
                className="cursor-pointer px-2 py-1 gap-2-1 hover:bg-gray-100"
                onClick={async (event: React.MouseEvent) => {
                  // event.preventDefault();
                  if (version == 2) {
                    await removeMediaClickHandler(event, kit_document, index);
                  } else {
                    showToast('WIP', 'danger');
                  }
                }}
              >
                <div className="flex flex-row items-center font-medium text-md p-0 gap-2">
                  <Trash2Icon className="w-4 h-4" />
                  Delete
                </div>
              </div>
            )}
          </Menu.Item>
        </div>
      </Menu.Items>
    );
  };
  const getMenuItemsVideo = (kit_document: KitDocumentModel, index: number) => {
    return (
      <Menu.Items className={"absolute -right-1 mt-2 w-48 focus:outline-none z-10" +
        (menuPosition == 'bottom'?'   origin-top-right top-full ' : ' origin-bottom-right bottom-full ')
      }>
        <div
          className={"absolute right-0 text-gray-300 text-center items-center flex w-4 h-4" +
        (menuPosition == 'bottom'?'  top-0  ' : ' bottom-0 ')
            
          }
          style={{
             zIndex: 51,
            top: menuPosition == 'bottom'?'-10px':'',
            bottom: menuPosition == 'top'?'-10px':'',
            right: '12px',
            width: '1rem',
          }}
        >
          <div
          
            className={"absolute   w-4 h-4 border-t-2 border-l-2 border-gray-300  bg-white" +
        (menuPosition == 'bottom'?' top-0 left-1/2 -translate-x-1/2 transform rotate-45 ' : ' bottom-0 left-1/2 transform -translate-x-1/2 ')

            }
            style={{
              zIndex: 51,
              '--tw-rotate':  menuPosition == 'bottom'?'45deg':'225deg',
              top: menuPosition == 'bottom'?'2px':'',
              bottom: menuPosition == 'top'?'2px':'',
              right: '1.5rem',
            }}
          />
        </div>

        <div className="rounded-md py-1 px-1 gap-1 border-gray-300 border bg-white box-shadow-100 ring-1 ring-black ring-opacity-5 flex flex-col">
          {/* <Menu.Item>
            {({ active }) => (
              <div
                className="cursor-pointer px-2 py-1 gap-2-1 hover:bg-gray-100"
                onClick={(event: React.MouseEvent) => {
                  // event.preventDefault();
                  if (version == 2) {
                    setMediaKitDocumentCropSelected(kit_document);
                    setshowCropModal(true);
                  } else {
                    showToast('WIP', 'danger');
                  }
                }}
              >
                <div className="flex flex-row items-center font-medium text-md p-0 gap-2">
                  <PencilIcon className="w-4 h-4" />
                  Edit
                </div>
              </div>
            )}
          </Menu.Item> */}
          <Menu.Item>
            {({ active }) => (
              <div
                className="cursor-pointer px-2 py-1 gap-2-1 hover:bg-gray-100"
                onClick={(event: React.MouseEvent) => {
                  // event.preventDefault();
                  if (version == 2) {
                    setMediaKitDocumentSelectedRename(kit_document);
                    if (viewMode == 'grid') {
                      setrefField('video_g');
                    } else {
                      setrefField('video_l');
                    }
                      setEditFileNameIndex(index);
                    setEditFileName(kit_document.file_name);
                  } else {
                    showToast('WIP', 'danger');
                  }
                }}
              >
                <div className="flex flex-row items-center font-medium text-md p-0 gap-2">
                  <PencilIcon className="w-4 h-4" />
                  Rename
                </div>
              </div>
            )}
          </Menu.Item>
          <Menu.Item>
            {({ active }) => (
              <div
                className="cursor-pointer px-2 py-1 gap-2-1 hover:bg-gray-100"
                onClick={(event: React.MouseEvent) => {
                  // event.preventDefault();
                  if (version == 2) {
                    setMediaKitDocumentSelected(kit_document);
                    setshowReplaceModal(true);
                  } else {
                    showToast('WIP', 'danger');
                  }
                }}
              >
                <div className="flex flex-row items-center font-medium text-md p-0 gap-2">
                  <RepeatIcon className="w-4 h-4" />
                  Replace
                </div>
              </div>
            )}
          </Menu.Item>
          <Menu.Item>
            {({ active }) => (
              <div
                className="cursor-pointer px-2 py-1 gap-2-1 hover:bg-gray-100"
                onClick={(event: React.MouseEvent) => {
                  setMediaKitDocumentSelected(kit_document);
                  setSelectedThumbnailKit(kit_document);
                }}
              >
                <div className="flex flex-row items-center font-medium text-md p-0 gap-2">
                  <CameraIcon className="w-4 h-4" />
                  Set Thumbnail
                </div>
              </div>
            )}
          </Menu.Item>
          <Menu.Item>
            {({ active }) => (
              <div
                className="cursor-pointer px-2 py-1 gap-2-1 hover:bg-gray-100"
                onClick={async (event: React.MouseEvent) => {
                  // event.preventDefault();
                  if (version == 2) {
                    await removeMediaClickHandler(event, kit_document, index);
                  } else {
                    showToast('WIP', 'danger');
                  }
                }}
              >
                <div className="flex flex-row items-center font-medium text-md p-0 gap-2">
                  <Trash2Icon className="w-4 h-4" />
                  Delete
                </div>
              </div>
            )}
          </Menu.Item>
        </div>
      </Menu.Items>
    );
  };
  type ElementLineInfo = {
  element: HTMLElement;
  lineNumber: number;
};

  /**
   * Calculates which flex line each child element of a flex-wrap container is on.
   * @param containerId The ID of the flex container element.
   * @returns An array of objects containing the element and its calculated line number.
   */
  function getFlexWrapLineInfo(containerId: string): ElementLineInfo[] {
    const container = document.getElementById(containerId);

    if (!container) {
      console.error(`Container with ID ${containerId} not found.`);
      return [];
    }

    const children = Array.from(container.children) as HTMLElement[];
    if (children.length === 0) {
      return [];
    }

    let lineCount = 1;
    let currentLineTop = -Infinity; // Initialize with a value guaranteed to be smaller than the first element's top

    const lineInfo: ElementLineInfo[] = [];

    children.forEach((child) => {
      // getBoundingClientRect provides the size and position relative to the viewport.
      const rect = child.getBoundingClientRect();
      const elementTop = Math.round(rect.top); // Rounding prevents float comparison issues

      // 1. Initialize the first line's top coordinate
      if (currentLineTop === -Infinity) {
        currentLineTop = elementTop;
      }

      // 2. Check for a wrap: If the current element's top coordinate is lower than the line's established top, it has wrapped to a new line.
      if (elementTop > currentLineTop) {
        // It wrapped! Increment the line count and set the new line's top coordinate.
        lineCount++;
        currentLineTop = elementTop;
      } 
      // 3. If the element is on the same line, its top coordinate will be equal (or slightly less, depending on element alignment).

      lineInfo.push({
        element: child,
        lineNumber: lineCount,
      });
    });

    return lineInfo;
  }

  const imageTab = () => {
    return (
      <>
        <div className=" w-full flex flex-col bg-white  gap-5 px-1 sm:px-7 py-2 border border-gray-300 rounded-md shadow-xl-0-6-14-8">
          <div className={" w-full flex items-center  gap-2-1 px-0 py-1" +
                  (mediaKitDocumentsImagePresent && showUploadMediaImage ?' flex-row justify-between items-start':' flex-col sm:flex-row justify-center sm:justify-between sm:items-start ')

          }>
            {mediaKitDocumentsImagePresent && (
              <div className=" flex flex-row font-semibold text-xl mt-1.5 ml-4">Upload Media</div>
            )}
            <div className=" flex ">
              {mediaKitDocumentsImagePresent && !showUploadMediaImage && (
                <>
                  {mediaSetting.imageAllowed > 0 && (
                    <>
                      <Button
                        variant="primary"
                        className="flex-1"
                        onClick={() => {
                          setIsUploadedMedia(false);
                          setshowUploadMediaImage(true);
                        }}
                      >
                        <div className="w-6 h-6  flex items-center justify-center">
                          <PlusIcon className="w-4-2 h-4-2" />
                        </div>
                        Add Media
                      </Button>
                    </>
                  )}
                </>
              )}

              {mediaKitDocumentsImagePresent && showUploadMediaImage && (
                <>
                  <div
                    className="w-6 h-6  flex items-center justify-center cursor-pointer"
                    onClick={() => {
                      setshowUploadMediaImage(false);
                      if (isUploadedMedia) {
                        setIsUploadedMedia(false);
                        refreshClicked();
                      }
                    }}
                  >
                    <XIcon className="w-4-2 h-4-2" />
                  </div>
                </>
              )}
            </div>
          </div>
          {mediaKitDocumentsImagePresent && !showUploadMediaImage && (
            <>
              {mediaSetting.imageAllowed <= 0 && (
                <div className="flex flex-col sm:flex-row items-center justify-center px-2-1 py-2-1 mt-4 gap-2 bg-blue-50 rounded-lg">
                  <InfoIcon className="w-4 h-4 opacity-100" strokeWidth={1.5} />
                  <div className="font-medium text-13 text-blue-600 text-center sm:text-left">
                    {'You’ve reached the maximum number of images allowed in your Media Kit.' }
                  </div>
                </div>

                // <div className="flex flex-row items-center justify-center px-2-1 py-2-1 mt-4 gap-2 relative rounded-md bg-green-200 border-green-400 border">
                //   <div className="font-medium font-xs">{'Upload limit reached.'}</div>
                // </div>
              )}
            </>
          )}
          {showUploadMediaImage && (
            <>
              {!mediaKitDocumentsImagePresent && (
                <p className="text-gray-900 text-center text-xl font-semibold">
                  Nothing here yet. Upload your media to get started...
                </p>
              )}
              <CustomUppyUploaderv2
                isReplaced={false}
                backendUrl={'/'}
                mediaType={KitDocumentType.Image}
                maxFileSizeMb={MaxImageSizeMb}
                maxUploadFiles={5}
                mediaSetting={mediaSetting}
                handleCloseUploader={() => {
                  setshowUploadMediaImage(false);
                  if (isUploadedMedia) {
                    setIsUploadedMedia(false);
                    refreshClicked();
                  }
                }}
                filesUploaded={async (fileUppy: any) => {
                  console.log('filesUploaded s');
                  await kitDocumentService.createKitDocument(
                    fileUppy,
                    KitCategories.media_kit_cat,
                    mediaKit.uuid
                  );
                  console.log('filesUploaded e');
                }}
                handleErrorMessage={function (error: string): void {
                  setErrorMessage(error);
                }}
                uploadCompleted={async () => {
                  setIsUploadedMedia(true);
                  await fetchMediaKits(1, true, false);
                }}
                validateSameFileName={function (filesUppy: any): string[] {
                  let sameFiles = [];
                  mediaKitDocuments.map((kit_document, index) => {
                    const files = filesUppy.filter((fileAdded) => {
                      return fileAdded.name.toLowerCase() == kit_document.file_name.toLowerCase();
                    });
                    if (files.length > 0) {
                      sameFiles = sameFiles.concat(files.map((item) => item.name));
                    }
                  });
                  console.log('sameFiles:', sameFiles);
                  return sameFiles;
                }}
              />
            </>
          )}
          {!isLoading && !mediaKitDocumentsImagePresent && (
            <>
              <div className="w-full">
                <img className="ml-auto mr-auto w-96 h-full object-cover" src={mk_empty} alt="" />
              </div>
            </>
          )}
        </div>
        {mediaKitDocumentsImagePresent && (
          <div className=" w-full flex flex-col gap-3">
            <div className=" flex flex-row font-semibold text-xl">Photos</div>
            {viewMode == 'grid' && (
              <div id="flex-container-image" className=" flex flex-row justify-center pt-2 gap-5 flex-wrap">
                {/* Media Item */}
                {mediaKitDocuments.map((kit_document, index) => {
                  if (!kit_document.file_content_type.startsWith('image')) {
                    return <></>;
                  }
                  return (
                    <>
                      <div
                        key={index}
                        id={'id_' + kit_document.id}
                        className={'flex flex-col w-40 bg-white rounded-lg items-center '}
                        draggable="true"
                        style={{
                          boxShadow:
                            '0px 0px 4px -1px rgba(0, 0, 0, 0.25), 0px 2px 10px -2px rgba(0, 0, 0, 0.15)',
                        }}
                      >
                        <a
                          target={'_blank'}
                          onClick={(e) => {
                            e.preventDefault();
                            setshowMediaBig(kit_document);
                          }}
                        >
                          <div className="flex flex-1 flex-col w-40 rounded-t-lg overflow-hidden cursor-pointer">
                            <FilePreviewer
                              file_url={kit_document.cropped_file_url ?? kit_document.file_url}
                              file_name={kit_document.file_name}
                              file_content_type={kit_document.file_content_type}
                              default_file_url={whiteBgSbProfile}
                            />
                          </div>
                        </a>
                        <div className="px-1 sm:px-4 py-2-1 w-full flex flex-row justify-between items-center gap-2-1">
                          <div className="text-xs font-medium flex justify-center items-center truncate">
                            {editFileNameIndex !== index && (
                              <span
                                onDoubleClick={() => {
                                  setMediaKitDocumentSelectedRename(kit_document);
                                  setrefField('image_g');
                                  setEditFileNameIndex(index);
                                  setEditFileName(kit_document.file_name);
                                }}
                                className="cursor-text truncate"
                                title={kit_document.file_name}
                              >
                                {kit_document.file_name}
                              </span>
                            )}
                            {editFileNameIndex == index && (
                              <>
                                <input
                                  ref={refMap['image_g']}
                                  onKeyDown={async (e) => {
                                    if (e.key === 'Enter') {
                                      // On Enter, save the new value and exit edit mode
                                      e.preventDefault();
                                      await renameFileMediaClickHandler(
                                        kit_document,
                                        index,
                                        e.currentTarget.value
                                      );
                                      setrefField('');
                                      setEditFileNameIndex(-1);
                                      // setIsHeaderEdit(false);
                                    } else if (e.key === 'Escape') {
                                      e.preventDefault();
                                      setrefField('');
                                      setEditFileNameIndex(-1);
                                      // On Escape, revert to the original value and exit edit mode
                                      // setValue('sb_status', selectedValue.id);
                                      // setIsHeaderEdit(false);
                                    }
                                  }}
                                  onBlur={async () => {
                                    await handleFileNameBlur(kit_document, index, editFileName);
                                  }}
                                  // ref={inputHeaderRef}
                                  value={editFileName}
                                  type="text"
                                  name="file_name"
                                  id="file_name"
                                  placeholder="file name"
                                  className="w-full flex-grow bg-white shadow-sm border border-gray-300 px-3 py-2 border-0 rounded-lg focus:shadow-outline text-left "
                                  onChange={(e) => setEditFileName(e.target.value)}
                                />
                              </>
                            )}
                          </div>
                          <Menu as="div" className="relative inline-block text-left w-8 h-8">
                            <Menu.Button
                              className={`flex  w-8 h-8 items-center justify-center transition
                                           hover:bg-gray-100 text-gray-500 rounded-full`}
                            >
                              <div className="w-4-2 h-4-2 flex items-center justify-center">
                                <EllipsisVerticalIcon className="w-4-2 h-4-2" />
                              </div>
                            </Menu.Button>

                            {getMenuItemsImage(kit_document, index)}
                          </Menu>
                        </div>
                      </div>
                    </>
                  );
                })}
              </div>
            )}
           {viewMode == 'list' && (
              <div className=" flex flex-col justify-center pt-2 gap-5 w-full sm:px-12">
                {/* Media Item */}
                {mediaKitDocuments.map((kit_document, index) => {
                  if (!kit_document.file_content_type.startsWith('image')) {
                    return <></>;
                  }
                  return (
                    <>
                      <div
                        key={index}
                        className={
                          'flex flex-row w-full bg-white rounded-lg items-center py-2 sm:px-2-1 gap-2 px-2.5'
                        }
                        style={{
                          boxShadow:
                            '0px 0px 4px -1px rgba(0, 0, 0, 0.25), 0px 2px 10px -2px rgba(0, 0, 0, 0.15)',
                        }}
                      >
                        <a
                          target={'_blank'}
                          onClick={(e) => {
                            e.preventDefault();
                            setshowMediaBig(kit_document);
                          }}
                        >
                          <div className="flex flex-col w-20 rounded-lg overflow-hidden cursor-pointer ">
                            <FilePreviewer
                              file_url={kit_document.cropped_file_url ?? kit_document.file_url}
                              file_name={kit_document.file_name}
                              file_content_type={kit_document.file_content_type}
                              default_file_url={whiteBgSbProfile}
                            />
                          </div>
                        </a>
                          <div className="px-1 sm:px-4 py-2 flex-1 flex items-start justify-between gap-2 min-w-0">
                          <div className="text-xs font-medium flex-1 min-w-0 overflow-hidden">
                            {editFileNameIndex !== index && (
                              <span
                                onDoubleClick={() => {
                                  setMediaKitDocumentSelectedRename(kit_document);
                                  setrefField('image_l');
                                  setEditFileNameIndex(index);
                                  setEditFileName(kit_document.file_name);
                                }}
                                className="cursor-text block truncate"
                                title={kit_document.file_name}
                              >
                                {kit_document.file_name}
                              </span>
                            )}
                            {editFileNameIndex == index && (
                              <>
                                <input
                                  ref={refMap['image_l']}
                                  onKeyDown={async (e) => {
                                    if (e.key === 'Enter') {
                                      // On Enter, save the new value and exit edit mode
                                      e.preventDefault();
                                      await renameFileMediaClickHandler(
                                        kit_document,
                                        index,
                                        e.currentTarget.value
                                      );
                                      setrefField('');
                                      setEditFileNameIndex(-1);
                                      // setIsHeaderEdit(false);
                                    } else if (e.key === 'Escape') {
                                      e.preventDefault();
                                      setrefField('');
                                      setEditFileNameIndex(-1);
                                      // On Escape, revert to the original value and exit edit mode
                                      // setValue('sb_status', selectedValue.id);
                                      // setIsHeaderEdit(false);
                                    }
                                  }}
                                  onBlur={async () => {
                                    await handleFileNameBlur(kit_document, index, editFileName);
                                  }}
                                  // ref={inputHeaderRef}
                                  value={editFileName}
                                  type="text"
                                  name="file_name"
                                  id="file_name"
                                  placeholder="file name"
                                  className="w-full flex-grow bg-white shadow-sm border border-gray-300 px-3 py-2 border-0 rounded-lg focus:shadow-outline text-left "
                                  onChange={(e) => setEditFileName(e.target.value)}
                                />
                              </>
                            )}
                          </div>
                          <Menu as="div" className="relative inline-block text-left">
                            <Menu.Button
                              className={`flex  w-8 h-8 items-center justify-center transition
                                           hover:bg-gray-100 text-gray-500`}

                            >
                              <div className="w-4-2 h-4-2 flex items-center justify-center">
                                <EllipsisVerticalIcon className="w-4-2 h-4-2" />
                              </div>
                            </Menu.Button>

                            {getMenuItemsImage(kit_document, index)}
                          </Menu>
                        </div>
                      </div>
                    </>
                  );
                })}
              </div>
            )}
          </div>
        )}
      </>
    );
  };
  const videoTab = () => {
    return (
      <>
        <div className=" w-full flex flex-col bg-white  gap-5 px-1 sm:px-7 py-5 border border-gray-300 rounded-md shadow-xl-0-6-14-8">
          <div className={" w-full flex items-center  gap-2-1 px-0 py-1" +
                  (mediaKitDocumentsVideoPresent && showUploadMediaVideo ?' flex-row justify-between items-start':' flex-col sm:flex-row justify-center sm:justify-between sm:items-start ')

          }>
            {mediaKitDocumentsVideoPresent && (
              <div className=" flex flex-row font-semibold text-xl mt-1.5">Upload Media</div>
            )}
            <div className=" flex">
              {mediaKitDocumentsVideoPresent && !showUploadMediaVideo && (
                <>
                  {mediaSetting.videoAllowed > 0 && (
                    <>
                      <Button
                        variant="primary"
                        className="flex-1"
                        onClick={() => {
                          setIsUploadedMedia(false);
                          setshowUploadMediaVideo(true);
                        }}
                      >
                        <div className="w-6 h-6  flex items-center justify-center">
                          <PlusIcon className="w-4-2 h-4-2" />
                        </div>
                        Add Media
                      </Button>
                    </>
                  )}
                </>
              )}

              {mediaKitDocumentsVideoPresent && showUploadMediaVideo && (
                <>
                  <div
                    className="w-6 h-6  flex items-center justify-center cursor-pointer"
                    onClick={() => {
                      setshowUploadMediaVideo(false);
                      if (isUploadedMedia) {
                        setIsUploadedMedia(false);
                        refreshClicked();
                      }
                    }}
                  >
                    <XIcon className="w-4-2 h-4-2" />
                  </div>
                </>
              )}
            </div>
          </div>
          {mediaKitDocumentsVideoPresent && !showUploadMediaVideo && (
            <>
              {mediaSetting.videoAllowed <= 0 && (
                                <div className="flex flex-col sm:flex-row items-center justify-center px-2-1 py-2-1 mt-4 gap-2 bg-blue-50 rounded-lg">
                  <InfoIcon className="w-4 h-4 opacity-100" strokeWidth={1.5} />
                  <div className="font-medium text-13 text-blue-600 text-center sm:text-left">
                    {'You’ve reached the maximum number of videos allowed in your Media Kit.' }
                  </div>
                </div>
                // <div className="flex flex-row items-center justify-center px-2-1 py-2-1 mt-4 gap-2 relative rounded-md bg-green-200 border-green-400 border">
                //   <div className="font-medium font-xs">{'Upload limit reached.'}</div>
                // </div>
              )}
            </>
          )}
          {showUploadMediaVideo && (
            <>
              {!mediaKitDocumentsVideoPresent && (
                <p className="text-gray-900 text-center text-xl font-semibold">
                  Nothing here yet. Upload your media to get started...
                </p>
              )}
              <CustomUppyUploaderv2
                isReplaced={false}
                backendUrl={'/'}
                mediaType={KitDocumentType.Video}
                maxFileSizeMb={MaxVideoSizeMb}
                maxUploadFiles={5}
                mediaSetting={mediaSetting}
                handleCloseUploader={() => {
                  setshowUploadMediaVideo(false);
                  if (isUploadedMedia) {
                    setIsUploadedMedia(false);
                    refreshClicked();
                  }
                }}
                filesUploaded={async (fileUppy: any) => {
                  await kitDocumentService.createKitDocument(
                    fileUppy,
                    KitCategories.media_kit_cat,
                    mediaKit.uuid
                  );
                }}
                handleErrorMessage={function (error: string): void {
                  setErrorMessage(error);
                }}
                uploadCompleted={async () => {
                  setIsUploadedMedia(true);
                  await fetchMediaKits(1, true, false);
                }}
                validateSameFileName={function (filesUppy: any): string[] {
                  let sameFiles = [];
                  mediaKitDocuments.map((kit_document, index) => {
                    const files = filesUppy.filter((fileAdded) => {
                      return fileAdded.name.toLowerCase() == kit_document.file_name.toLowerCase();
                    });
                    if (files.length > 0) {
                      sameFiles = sameFiles.concat(files.map((item) => item.name));
                    }
                  });
                  console.log('sameFiles:', sameFiles);
                  return sameFiles;
                }}
              />
            </>
          )}
          {isLoading && !mediaKitDocumentsVideoPresent && (
            <>
              <div className="w-full">
                Refreshing
              </div>
            </>
          )}
          {!isLoading && !mediaKitDocumentsVideoPresent && (
            <>
              <div className="w-full">
                <img className="ml-auto mr-auto w-96 h-full object-cover" src={mk_empty} alt="" />
              </div>
            </>
          )}
        </div>
        {mediaKitDocumentsVideoPresent && (
          <div className=" w-full flex flex-col gap-3">
            <div className=" flex flex-row font-semibold text-xl">Videos</div>
            {viewMode == 'grid' &&  (
              <div 
              id="flex-container-video"
              className=" flex flex-row justify-center pt-2 gap-5 flex-wrap">
                {/* Media Item */}
                {mediaKitDocuments.map((kit_document, index) => {
                  if (!kit_document.file_content_type.startsWith('video')) {
                    return <></>;
                  }
                  return (
                    <>
                      <div
                        id={'id_' + kit_document.id}
                        key={index}
                        className={'flex flex-col bg-white rounded-lg items-center '}
                        draggable="true"
                        style={{
                          width: '15.625rem',
                          boxShadow:
                            '0px 0px 4px -1px rgba(0, 0, 0, 0.25), 0px 2px 10px -2px rgba(0, 0, 0, 0.15)',
                        }}
                        // onDragStart={(e) => handleDragStart(e, kit_document)}
                        // onDragOver={handleDragOver}
                      >
                        <a
                          target={'_blank'}
                          onClick={(e) => {
                            e.preventDefault();
                            setshowMediaBig(kit_document);
                          }}
                        >
                          <div className="flex flex-1 flex-col rounded-t-lg overflow-hidden cursor-pointer">
                            <FilePreviewer
                              file_url={
                                kit_document.file_content_type.startsWith('image') ? 
                                (kit_document.cropped_file_url ??
                                kit_document.file_url) : 
                                kit_document.file_url
                              }
                              poster_url={
                                kit_document.file_content_type.startsWith('image') ? '' : 
                                kit_document.cropped_file_url
                              }
                              file_name={kit_document.file_name}
                              file_content_type={
                                kit_document.file_content_type
                              }

                              showControl={false}
                              default_file_url={whiteBgSbProfile}
                              dynamicHeight={false}
                              // file_url={kit_document.cropped_file_url ?? kit_document.file_url}
                              // file_name={kit_document.file_name}
                              // file_content_type={kit_document.cropped_file_url ? 'image/png' : kit_document.file_content_type}
                              // default_file_url={whiteBgSbProfile}
                              // isThumbnail={!!kit_document.cropped_file_url}
                            />
                          </div>
                        </a>
                        <div className="px-1 sm:px-4 py-2-1 w-full flex flex-row justify-between items-center gap-2-1">
                          <div className="text-xs font-medium flex justify-center items-center truncate">
                            {editFileNameIndex !== index && (
                              <span
                                onDoubleClick={() => {
                                  setMediaKitDocumentSelectedRename(kit_document);
                                  setrefField('video_g');
                                  setEditFileNameIndex(index);
                                  setEditFileName(kit_document.file_name);
                                }}
                                className="cursor-text truncate"
                                title={kit_document.file_name}
                              >
                                {kit_document.file_name}
                              </span>
                            )}
                            {editFileNameIndex == index && (
                              <>
                                <input
                                  ref={refMap['video_g']}
                                  onKeyDown={async (e) => {
                                    if (e.key === 'Enter') {
                                      // On Enter, save the new value and exit edit mode
                                      e.preventDefault();
                                      await renameFileMediaClickHandler(
                                        kit_document,
                                        index,
                                        e.currentTarget.value
                                      );
                                      setrefField('');
                                      setEditFileNameIndex(-1);
                                      // setIsHeaderEdit(false);
                                    } else if (e.key === 'Escape') {
                                      e.preventDefault();
                                      setrefField('');
                                      setEditFileNameIndex(-1);
                                      // On Escape, revert to the original value and exit edit mode
                                      // setValue('sb_status', selectedValue.id);
                                      // setIsHeaderEdit(false);
                                    }
                                  }}
                                  onBlur={async () => {
                                    await handleFileNameBlur(kit_document, index, editFileName);
                                  }}
                                  // ref={inputHeaderRef}
                                  value={editFileName}
                                  type="text"
                                  name="file_name"
                                  id="file_name"
                                  placeholder="file name"
                                  className="w-full flex-grow bg-white shadow-sm border border-gray-300 px-3 py-2 border-0 rounded-lg focus:shadow-outline text-left "
                                  onChange={(e) => setEditFileName(e.target.value)}
                                />
                              </>
                            )}
                          </div>
                          <Menu as="div" className="relative inline-block text-left w-8 h-8">
                            <Menu.Button
                              className={`flex  w-8 h-8 items-center justify-center transition
                                           hover:bg-gray-100 text-gray-500`}
                            >
                              <div className="w-4-2 h-4-2 flex items-center justify-center">
                                <EllipsisVerticalIcon className="w-4-2 h-4-2" />
                              </div>
                            </Menu.Button>

                            {getMenuItemsVideo(kit_document, index)}
                          </Menu>
                        </div>
                      </div>
                    </>
                  );
                })}
              </div>
            )}
            {viewMode == 'list' && (
              <div className=" flex flex-col justify-center pt-2 gap-5 w-full sm:px-12">
                {/* Media Item */}
                {mediaKitDocuments.map((kit_document, index) => {
                  if (!kit_document.file_content_type.startsWith('video')) {
                    return <></>;
                  }
                  return (
                    <>
                      <div
                        key={index}
                        className={
                          'flex flex-row w-full bg-white rounded-lg items-center py-2 sm:px-2-1 gap-2 px-2.5'
                        }
                        style={{
                          boxShadow:
                            '0px 0px 4px -1px rgba(0, 0, 0, 0.25), 0px 2px 10px -2px rgba(0, 0, 0, 0.15)',
                        }}
                      >
                        <a
                          target={'_blank'}
                          onClick={(e) => {
                            e.preventDefault();
                            setshowMediaBig(kit_document);
                          }}
                        >
                          <div
                            className="flex flex-col rounded-lg overflow-hidden cursor-pointer flex-shrink-0"
                            style={{
                              width: '8.125rem',
                            }}
                          >
                            <FilePreviewer
                              file_url={
                                kit_document.file_content_type.startsWith('image') ? 
                                (kit_document.cropped_file_url ??
                                kit_document.file_url) : 
                                kit_document.file_url
                              }
                              poster_url={
                                kit_document.file_content_type.startsWith('image') ? '' : 
                                kit_document.cropped_file_url
                              }
                              file_name={kit_document.file_name}
                              file_content_type={
                                kit_document.file_content_type
                              }

                              showControl={false}
                              default_file_url={whiteBgSbProfile}

                              // file_url={kit_document.cropped_file_url ?? kit_document.file_url}
                              // file_name={kit_document.file_name}
                              // file_content_type={kit_document.cropped_file_url ? 'image/png' : kit_document.file_content_type}
                              // default_file_url={whiteBgSbProfile}
                              // isThumbnail={!!kit_document.cropped_file_url}
                            />
                          </div>
                        </a>
                        <div className="px-1 sm:px-4 py-2 flex-1 flex items-center justify-between gap-2 min-w-0">
                          <div className="text-xs font-medium flex justify-start items-center truncate">
                            {editFileNameIndex !== index && (
                              <span
                                onDoubleClick={() => {
                                  setMediaKitDocumentSelectedRename(kit_document);
                                  setrefField('video_l');
                                  setEditFileNameIndex(index);
                                  setEditFileName(kit_document.file_name);
                                }}
                                className="cursor-text truncate"
                                title={kit_document.file_name}
                              >
                                {kit_document.file_name}
                              </span>
                            )}
                            {editFileNameIndex == index && (
                              <>
                                <input
                                  ref={refMap['video_l']}
                                  onKeyDown={async (e) => {
                                    if (e.key === 'Enter') {
                                      // On Enter, save the new value and exit edit mode
                                      e.preventDefault();
                                      await renameFileMediaClickHandler(
                                        kit_document,
                                        index,
                                        e.currentTarget.value
                                      );
                                      setrefField('');
                                      setEditFileNameIndex(-1);
                                      // setIsHeaderEdit(false);
                                    } else if (e.key === 'Escape') {
                                      e.preventDefault();
                                      setrefField('');
                                      setEditFileNameIndex(-1);
                                      // On Escape, revert to the original value and exit edit mode
                                      // setValue('sb_status', selectedValue.id);
                                      // setIsHeaderEdit(false);
                                    }
                                  }}
                                  onBlur={async () => {
                                    await handleFileNameBlur(kit_document, index, editFileName);
                                  }}
                                  // ref={inputHeaderRef}
                                  value={editFileName}
                                  type="text"
                                  name="file_name"
                                  id="file_name"
                                  placeholder="file name"
                                  className="w-full flex-grow bg-white shadow-sm border border-gray-300 px-3 py-2 border-0 rounded-lg focus:shadow-outline text-left "
                                  onChange={(e) => setEditFileName(e.target.value)}
                                />
                              </>
                            )}
                          </div>
                          <Menu as="div" className="relative inline-block text-left w-8 h-8">
                            <Menu.Button
                              className={`flex  w-8 h-8 items-center justify-center transition
                                           hover:bg-gray-100 text-gray-500`}
                            >
                              <div className="w-4-2 h-4-2 flex items-center justify-center">
                                <EllipsisVerticalIcon className="w-4-2 h-4-2" />
                              </div>
                            </Menu.Button>

                            {getMenuItemsVideo(kit_document, index)}
                          </Menu>
                        </div>
                      </div>
                    </>
                  );
                })}
              </div>
            )}
          </div>
        )}
      </>
    );
  };

  const getMenuItemsFilter = () => {
    return (
      <Menu.Items className="absolute -right-0 mt-2 w-48 origin-top-right focus:outline-none z-10">
        <div
          className="absolute right-0 text-gray-300 text-center items-center flex w-4 h-4"
          style={{
            zIndex: 51,
            top: '-10px',
            right: '30px',
            width: '1rem',
          }}
        >
          <div
            className="absolute right-1/2 -translate-x-1/2 -top-[1px] w-4 h-4 border-t-2 border-l-2 border-gray-300 transform rotate-45 bg-white"
            style={{
              zIndex: 51,
              top: '2px',
              left: '1.5rem',
            }}
          />
        </div>

        <div className="rounded-md py-1 px-1 gap-1 border-gray-300 border bg-white box-shadow-100 ring-1 ring-black ring-opacity-5 flex flex-col">
          <Menu.Item>
            {({ active }) => (
              <div
                className="flex sm:hidden cursor-pointer px-2 py-1 gap-2-1 hover:bg-gray-100"
                onClick={(event: React.MouseEvent) => {
                setViewMode('grid')
                }}
              >
                <div className="flex flex-row items-center font-medium text-md p-0 gap-2">
                  <div className="w-6 h-6 p-3px flex items-center justify-center">
                    <LayoutGridIcon className="w-4-2 h-4-2" aria-hidden="true" />
                  </div>
                <div className="flex flex-row items-center">
                  Grid View
                </div>
              </div>
              </div>
            )}
          </Menu.Item>
           <Menu.Item>
            {({ active }) => (
              <div
                className="flex sm:hidden cursor-pointer px-2 py-1 gap-2-1 hover:bg-gray-100"
                onClick={(event: React.MouseEvent) => {
                setViewMode('list')
                }}
              >
                <div className="flex flex-row items-center font-medium text-md p-0 gap-2">
                  <div className="w-6 h-6 p-3px flex items-center justify-center">
                    <LayoutListIcon className="w-4-2 h-4-2" aria-hidden="true" />
                  </div>
                  <div className="flex flex-row items-center">
                    List View
                  </div>
              </div>
              </div>
            )}
          </Menu.Item>
          <hr className='py-2 flex sm:hidden ' />
          <Menu.Item>
            {({ active }) => (
              <div
                className="cursor-pointer px-2 py-1 gap-2-1 hover:bg-gray-100"
                onClick={(event: React.MouseEvent) => {
                  // event.preventDefault();
                  if (sortMode != 'new') {
                    setIsLoading(true);
                    setNoMoreData('');
                    setPage(1);
                    setMediaKitDocuments([]);
                    setSortMode('new');
                  }
                  if (version == 2) {
                  } else {
                    showToast('WIP', 'danger');
                  }
                }}
              >
                <div className="flex flex-row items-center font-poppins font-medium text-sm leading-none tracking-normal align-middle text-gray-700 p-0 gap-2">
                  <div className="w-6 h-6 p-3px flex items-center justify-center">
                  <ListFilterIcon className="w-4-2 h-4-2" aria-hidden="true" />
                  </div>
                  <div className="flex flex-row items-center">
                  Newest first
                  </div>
                </div>
              </div>
            )}
          </Menu.Item>
          <Menu.Item>
            {({ active }) => (
              <div
                className="cursor-pointer px-2 py-1 gap-2-1 hover:bg-gray-100"
                onClick={(event: React.MouseEvent) => {
                  // event.preventDefault();
                  if (version == 2) {
                    if (sortMode != 'old') {
                      setIsLoading(true);
                      setNoMoreData('');
                      setPage(1);
                      setMediaKitDocuments([]);
                      setSortMode('old');
                    }
                  } else {
                    showToast('WIP', 'danger');
                  }
                }}
              >
                <div className="flex flex-row items-center font-poppins font-medium text-sm leading-none tracking-normal align-middle text-gray-700 p-0 gap-2">
                                    <div className="w-6 h-6 p-3px flex items-center justify-center">
                  <ListFilterIcon className="w-4-2 h-4-2" aria-hidden="true" />
                  </div>
                  <div className="flex flex-row items-center">
                  Oldest first
                  </div>

                  
                </div>
              </div>
            )}
          </Menu.Item>
          <Menu.Item>
            {({ active }) => (
              <div
                className="cursor-pointer px-2 py-1 gap-2-1 hover:bg-gray-100"
                onClick={(event: React.MouseEvent) => {
                  // event.preventDefault();
                  if (version == 2) {
                    if (sortMode != 'name') {
                      setIsLoading(true);
                      setNoMoreData('');
                      setPage(1);
                      setMediaKitDocuments([]);
                      setSortMode('name');
                    }
                  } else {
                    showToast('WIP', 'danger');
                  }
                }}
              >
                <div className="flex flex-row items-center font-poppins font-medium text-sm leading-none tracking-normal align-middle text-gray-700 p-0 gap-2">
                                    <div className="w-6 h-6 p-3px flex items-center justify-center">
                  <ListFilterIcon className="w-4-2 h-4-2" aria-hidden="true" />
                  </div>
                  <div className="flex flex-row items-center">
                  Name (A-Z)
                  </div>

                  
                </div>
              </div>
            )}
          </Menu.Item>
        </div>
      </Menu.Items>
    );
  };
  const updateUrl = useCallback((newPath) => {
    if (typeof window !== 'undefined' && window.history.pushState) {
      const newUrl = `${window.location.origin}${newPath}`;
      window.history.pushState({ path: newUrl }, '', newUrl);
    }
  }, []);

  const handleFilterChange = (filterValue) => {
    const newPath = `/media_kits?tab=${encodeURIComponent(filterValue)}`;
    updateUrl(newPath);
  };

  return (
    <div className="w-full flex flex-col flex-1 mx-auto pb-32">
      <div className="w-full px-0 sm:px-4 mx-auto">
        <div className="flex flex-col relative w-full relative">
          {errorMessage.length > 0 && (
            <div className="flex flex-row px-2-1 py-2-1 gap-2 relative rounded-md bg-red-701 border-red-450 border">
              <CircleXIcon className="w-6 h-6" />
              <div className="font-medium font-xs">{errorMessage}</div>
            </div>
          )}
          <div className="mt-1 justify-items-center p-0 sm:p-2 gap-8 flex flex-col">
            <div className="flex flex-row border-b  gap-2 justify-between items-center">
              <div className=" w-full flex flex-row">
                <button
                  onClick={() => {
                    handleFilterChange('photos');
                    setTabSelected('photos');
                  }}
                  className={
                    'py-5 px-4 ' +
                    (tabSelected == 'photos' ? 'border-b-2 border-blue-500 text-blue-500' : '')
                  }
                >
                  Photos
                </button>
                <button
                  onClick={() => {
                    handleFilterChange('videos');
                    setTabSelected('videos');
                  }}
                  className={
                    'py-5 px-4 ' +
                    (tabSelected == 'videos' ? 'border-b-2 border-blue-500 text-blue-500' : '')
                  }
                >
                  Videos
                </button>
              </div>
              {/* View Toggle Buttons */}
              <div className="flex flex-1 items-center gap-2-1 pr-5 justify-end">
                <div className="flex items-center gap-2-1">
                  <Button
                    id="layout_grid_id"
                    variant="secondary"
                    btn_size="small"
                    className={`hidden sm:flex ${
                      viewMode === 'grid'
                        ? 'bg-indigo-50 text-blue-500'
                        : 'text-gray-600 hover:text-black'
                    }`}
                    onClick={() => {
                      setViewMode('grid');
                    }}
                  >
                    <div className="w-6 h-6 p-3px flex items-center justify-center">
                      <LayoutGridIcon className="w-4-2 h-4-2" aria-hidden="true" />
                    </div>
                  </Button>

                  <Button
                    id="layout_list_id"
                    variant="secondary"
                    btn_size="small"
                    className={`hidden sm:flex ${
                      viewMode === 'list'
                        ? 'bg-indigo-50 text-blue-500'
                        : 'text-gray-600 hover:text-black'
                    }`}
                    onClick={() => {
                      setViewMode('list');
                    }}
                  >
                    <div className="w-6 h-6 p-3px flex items-center justify-center">
                      <LayoutListIcon className="w-4-2 h-4-2" aria-hidden="true" />
                    </div>
                  </Button>
                  <div
                    className="hidden sm:block border border-gray-200" 
                    style={{
                      width: '1px',
                      height: '-webkit-fill-available',
                      maxHeight: '2.625rem',
                    }}
                  ></div>
                  <Menu as="div" className="relative inline-block text-left">
                    <Menu.Button
                      id="layout_sort_id"
                      className={`flex items-center justify-center rounded-md px-4 py-2 gap-x-2.5 flex-row border border-gray-300 bg-white box-shadow-100 text-sm font-semibold text-gray-600 hover:text-black`}
                    > 
                    <div className="hidden sm:flex">
                      <div className="w-6 h-6 p-3px flex items-center justify-center">
                        <ListFilterIcon className="w-4-2 h-4-2" aria-hidden="true" />
                      </div>
                    </div>
                      
                    <div className="flex sm:hidden">
                      <div className="w-6 h-6 p-3px flex items-center justify-center">
                        <EllipsisVerticalIcon className="w-5 h-5" aria-hidden="true" />
                      </div>
                      </div>
                    </Menu.Button>
                    {getMenuItemsFilter()}
                  </Menu>
                </div>
              </div>
              {/* View Toggle Buttons end */}
            </div>
            {tabSelected == 'photos' && imageTab()}
            {tabSelected == 'videos' && videoTab()}
          </div>
        </div>
      </div>
      <ConfirmationDialog
        title="Delete media?"
        description="Are you sure you want to delete this media? This media and its details will be permanently deleted."
        onCancelLabel="Cancel"
        onCancelAction={() => hideDeleteConfirm()}
        onConfirmLabel="Confirm"
        onConfirmAction={handleDeleteMediaClicked}
        isOpen={showDeleteConfirmationModal}
        onClose={() => hideDeleteConfirm()}
        icon={
          <div className="rounded-full p-3 bg-red-200">
            <TriangleAlertIcon className="w-6 h-6 text-red-500 " />
          </div>
        }
      />
      <ConfirmationDialog
        title="Media is in use"
        description="This media is currently used in one or more kits. If you delete it, it will be removed from those kits and permanently deleted."
        onCancelLabel="Cancel"
        onCancelAction={() => { setShowForceDeleteModal(false); setKitDocumentDelete(null); }}
        onConfirmLabel="Delete anyway"
        onConfirmAction={handleForceDeleteClicked}
        isOpen={showForceDeleteModal}
        onClose={() => { setShowForceDeleteModal(false); setKitDocumentDelete(null); }}
        icon={
          <div className="rounded-full p-3 bg-red-200">
            <FileXIcon className="w-6 h-6 text-red-500" />
          </div>
        }
      />
      {showReplaceModal && mediaKitDocumentSelected && (
        <Transition.Root show={showReplaceModal} as={Fragment}>
          <Dialog
            as="div"
            className="relative z-50"
            onClose={() => {
              setshowReplaceModal(false);
              setMediaKitDocumentSelected(null);
            }}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-customGray" />
            </Transition.Child>

            <div className="fixed z-10 hidden-after-load inset-0 overflow-y-auto">
              <div className="flex items-end justify-center justify-items-center items-center min-h-full pt-4 px-4 pb-8 text-center sm:block sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                >
                  <Dialog.Panel className="inline-block align-bottom w-11/12 bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all my-48 sm:align-middle sm:max-w-sm sm:w-full sm:p-6">
                    {/* Header */}
                    <div className="flex items-center justify-between px-1 sm:px-6 py-4">
                      <div className="flex flex-row font-semibold text-xl">Replace Media</div>
                      <button
                        type="button"
                        className="flex h-8 w-8 items-center justify-center rounded-md hover:bg-gray-100"
                        onClick={() => {
                          setshowReplaceModal(false);
                          setMediaKitDocumentSelected(null);
                        }}
                      >
                        <span className="sr-only">Close menu</span>
                        <XIcon className="h-6 w-6 text-gray-400" aria-hidden="true" />
                      </button>
                    </div>
                    <div className="w-full flex flex-row items-start justify-center">
                      <div className="bg-white w-full flex flex-col gap-6">
                        <div className="flex flex-col px-1 sm:px-8 pt-5 pb-8 gap-2-1">
                          <CustomUppyUploaderv2
                            isReplaced={true}
                            backendUrl={'/'}
                            mediaType={
                              mediaKitDocumentSelected.file_content_type.indexOf('image') >= 0
                                ? KitDocumentType.Image
                                : KitDocumentType.Video
                            }
                            maxFileSizeMb={
                              mediaKitDocumentSelected.file_content_type.indexOf('image') >= 0
                                ? MaxImageSizeMb
                                : MaxVideoSizeMb
                            }
                            mediaSetting={{
                              imageAllowed: 1,
                              videoAllowed: 1,
                              imageCount: 0,
                              videoCount: 0
                            }}
                            maxUploadFiles={1}
                            handleCloseUploader={() => {
                              setshowReplaceModal(false);
                              setMediaKitDocumentSelected(null);
                              if (isUploadedMedia) {
                                setIsUploadedMedia(false);
                                refreshClicked();
                              }
                            }}
                            filesUploaded={async (fileUppy: any) => {
                              await kitDocumentService.updateKitDocument(
                                fileUppy,
                                KitCategories.media_kit_cat,
                                mediaKit.uuid,
                                mediaKitDocumentSelected.uuid,
                                1
                              );
                            }}
                            handleErrorMessage={(error: string) => setErrorMessage(error)}
                            uploadCompleted={async () => setIsUploadedMedia(true)}
                          />
                        </div>
                      </div>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
      )}
      {showCropModal && (
        <Transition.Root show={showCropModal} as={Fragment}>
          <Dialog
            as="div"
            className="relative z-50"
            onClose={() => {
              setshowCropModal(false);
              setMediaKitDocumentCropSelected(null);
            }}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-customGray" />
            </Transition.Child>

            <div className="fixed z-10 hidden-after-load inset-0 overflow-y-auto">
              <div className="flex items-end justify-center justify-items-center items-center min-h-full pt-4 px-4 pb-8 text-center sm:block sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                >
                  <Dialog.Panel
                    className="inline-block align-bottom w-11/12 bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all my-48 sm:align-middle sm:max-w-sm sm:w-full sm:p-6"
                    // style={{
                    //   height: '80vh',
                    //   maxHeight: '600px',
                    //   // width: '80vw',
                    //   maxWidth: '940px',
                    // }}
                  >
                    {/* Header */}
                    <div className="flex items-center justify-between px-6 py-4  border-gray-200">
                      <h2 className="text-lg font-medium text-gray-900">Crop your Image</h2>
                      <button
                        type="button"
                        className="flex h-8 w-8 items-center justify-center rounded-md hover:bg-gray-100"
                        onClick={() => {
                          setshowCropModal(false);
                          setMediaKitDocumentCropSelected(null);
                        }}
                      >
                        <span className="sr-only">Close menu</span>
                        <XIcon className="h-6 w-6 text-gray-400" aria-hidden="true" />
                      </button>
                    </div>
                    <div
                      className="mt-4 md:mt-8 mb-4  w-full"
                      style={
                        {
                          // height: '80vh',
                          // maxHeight: '600px',
                          // maxWidth: '940px',
                        }
                      }
                    >
                      {mediaKitDocumentCropSelected && (
                        <>
                          {/* MODAL */}
                          <CropImage
                            kitDocumentModel={mediaKitDocumentCropSelected}
                            record_uuid={mediaKit.uuid}
                            maxFileSizeMb={5}
                            dialogCloseHandler={function (): void {
                              // refreshClicked();
                              setshowCropModal(false);
                              setMediaKitDocumentCropSelected(null);
                            }}
                            refreshMediaHandler={function (): void {
                              refreshClicked();
                              setshowCropModal(false);
                              setMediaKitDocumentCropSelected(null);
                            }}
                          />
                          {/* <div className="mt-4 md:mt-8 mb-4  w-full" data-crop-image-target="container">
                                <img data-crop-image-target="image" src={mediaKitDocumentSelected.file_url}
                                className=""/>
                              </div> */}
                        </>
                      )}
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
      )}
      {selectedThumbnailKit && (
        <Transition.Root show={!!selectedThumbnailKit} as={Fragment}>
          <Dialog as="div" className="relative z-[60]" onClose={() => setSelectedThumbnailKit(null)}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-black/60" />
            </Transition.Child>

            <div className="fixed inset-0 overflow-y-auto">
              <div className="flex min-h-full items-center justify-center p-4 bg-gray-600 bg-opacity-80 backdrop-blur-sm transition-opacity">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                >
                  <Dialog.Panel className="w-full max-w-2xl bg-white rounded-xl shadow-2xl overflow-hidden">
                    <div className="px-6 py-4 border-b flex justify-between items-center">
                      <h3 className="text-xl font-semibold text-gray-900">Set Video Thumbnail</h3>
                      <button
                        onClick={() => setSelectedThumbnailKit(null)}
                        className="text-gray-400 hover:text-gray-500"
                      >
                        <XIcon className="w-6 h-6" />
                      </button>
                    </div>
                    <div className="p-6">
                      <VideoThumbnailSelector
                        kitDocumentModel={selectedThumbnailKit}
                        record_uuid={mediaKit?.uuid || ''}
                        refreshMediaHandler={()=>{
                          // setMediaKitDocumentsImagePresent(false);
                          setMediaKitDocumentsVideoPresent(false);
                          setshowUploadMediaVideo(false);
                          setIsUploadedMedia(false);
                          refreshClicked();
                        }}
                        dialogCloseHandler={() => setSelectedThumbnailKit(null)}
                      />
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
      )}
      {showMediaBig && (
        <ViewMediaModel
          kit_document={showMediaBig}
          dialogCloseHandler={function (): void {
            setshowMediaBig(null);
          }}
        />
      )}
    </div>
  );
}
